export default function HeroAbout() {
  return (
    <section
      id="about"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f8f49c54fa41b754047145b585bea47d.jpg"
          alt="background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/55 to-black/65" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div>
            <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-white/60 mb-6 border border-white/20 px-4 py-1.5 rounded-full">
              iOS Development Studio
            </span>
            <h2 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
              Crafting Premium
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-300">
                iOS Experiences
              </span>
            </h2>
            <p className="text-lg text-white/75 leading-relaxed max-w-xl mb-8">
              MONTANA OOD is a team of experts developing modern applications
              for the iOS platform. We combine deep technical knowledge with
              thoughtful design to deliver products that genuinely improve
              people&apos;s digital lives.
            </p>
            <p className="text-base text-white/55 leading-relaxed max-w-xl">
              Our focus is on security, performance, and simplicity — building
              tools that users trust and rely on every day. From protecting
              online privacy to optimizing device performance, we engineer
              solutions that make a real difference.
            </p>


          </div>

          {/* Right: Visual card */}
          <div className="hidden lg:flex justify-end">
            <div className="relative w-[420px]">
              <div className="bg-white/10 backdrop-blur-xl border border-white/15 rounded-3xl p-10">
                <div className="flex items-center gap-3 mb-8">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-400/20">
                    <i className="ri-shield-check-line text-emerald-400 text-xl" />
                  </div>
                  <span className="text-white font-semibold text-lg">Our Mission</span>
                </div>
                <p className="text-white/70 text-base leading-relaxed mb-8">
                  To enhance user experience and improve the security of mobile
                  devices through thoughtfully engineered iOS applications.
                </p>
                <div className="space-y-4">
                  {[
                    { icon: "ri-lock-line", text: "Privacy-first approach" },
                    { icon: "ri-speed-line", text: "Performance optimized" },
                    { icon: "ri-apple-line", text: "Native iOS design" },
                    { icon: "ri-user-heart-line", text: "User-centric UX" },
                  ].map((item) => (
                    <div key={item.text} className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10">
                        <i className={`${item.icon} text-white/80 text-sm`} />
                      </div>
                      <span className="text-white/70 text-sm">{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
              {/* Decorative glow */}
              <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-emerald-400/20 rounded-full blur-3xl pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
